|<template>
  <div class="bottomView">
    <div class="bottomTop">
      <div class="left">
        <div class="leftDetail"
        v-for="item in endList1"
        :key="item.id">
          {{item.title}}
        </div>
      </div>
      <div class="middle">
        <div class="middleDetail"
        v-for="item in endList2"
        :key="item.id">
          {{item.title}}
        </div>
      </div>
      <div class="right">
        <div class="rightDetail"
        v-for="item in endList3"
        :key="item.id">
          {{item.title}}
        </div>
      </div>
    </div>
    <div class="bottomEnd">
      <img src="@/assets/bottomImg.png" alt="">
    </div>
  </div>
</template>
<script>
import { getSiteConfigDetail } from '@/apis/modules/Information/index.js';
import { getHost } from '@/utils/domain';
export default {
  name: 'bottomView',
  data () {
    return {
      endList1: [
        {
          id: 1,
          title: '关于我们'
        },
        {
          id: 2,
          title: '联系我们'
        },
        {
          id: 3,
          title: '加盟我们'
        },
        {
          id: 4,
          title: '客服中心'
        }
      ],
      endList2: [
        {
          id: 1,
          title: '隐私保护'
        },
        {
          id: 2,
          title: '服务条款'
        },
        {
          id: 3,
          title: '使用与帮助'
        },
        {
          id: 4,
          title: '网站地图'
        },
        {
          id: 5,
          title: '服务与产品'
        }
      ],
      // endList3: [
      //   {
      //     id: 1,
      //     title: '服务热线：18688796627'
      //   },
      //   {
      //     id: 2,
      //     title: '版权所有  |  助力通'
      //   },
      //   {
      //     id: 3,
      //     title: '技术支持 广东助力通物流科技有限公司'
      //   },
      // ],
      endList3: [],
      siteInfo: {
        hotLine: '',
        copyright: '',
        register: ''
      }
    }
  },
  async mounted() {
    try {
      const res = await getSiteConfigDetail({ host: getHost() });
      if (
        res &&
        res.statusCode === 20000 &&
        res.data &&
        res.data.conf &&
        res.data.conf.featuredArticles &&
        res.data.conf.featuredArticles.contactUs &&
        res.data.conf.featuredArticles.contactUs.other
      ) {
        const other = res.data.conf.featuredArticles.contactUs.other;
        this.siteInfo.hotLine = other.hotLine || '';
        this.siteInfo.copyright = other.copyright || '';
        this.siteInfo.register = other.register || '';
        this.endList3 = [
          {
            id: 1,
            title: `服务热线：${this.siteInfo.hotLine}`
          },
          {
            id: 2,
            title: `版权所有  |  ${this.siteInfo.copyright}`
          },
          {
            id: 3,
            title: this.siteInfo.register
          }
        ];
      }
    } catch (e) {}
  }
}
</script>

<style scoped lang="scss">
.bottomView{
  width: 100%;
  background-color: #001B51;
  display: flex;
  flex-direction: column;
  align-items: center;
  .bottomTop{
    height: 196px;
    width: 1400px;
    display: flex;
    justify-content: center;
    color: white;
    font-size: 16px;
    line-height: 24px;
    .left{
      background: rgba(255, 255, 255, 0.1);
      width: 306px;
      display: flex;
      flex-wrap: wrap;
      padding-left: 24px;
      margin: 32px 0px 32px 0px;
      .leftDetail{
        display: flex;
        width: 50%;
        align-items: center;
      }
    }
    .middle{
      background: rgba(255, 255, 255, 0.1);
      width: 434px;
      flex-wrap: wrap;
      display: flex;
      flex-wrap: wrap;
      padding-left: 24px;
      margin: 32px;
      .middleDetail{
        display: flex;
        width: 33%;
        align-items: center;
      }
    }
    .right{
      background: rgba(255, 255, 255, 0.1);
      width: 596.2px;
      display: flex;
      flex-wrap: wrap;
      margin: 32px 0;
      flex-wrap: wrap;
      padding-left: 24px;
      .rightDetail{
        display: flex;
        width: 35%;
        white-space: nowrap;
        align-items: center;
      }
    }
  }
  .bottomEnd{
    width: 100%;
    background: #001E5B;
    box-sizing: border-box;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    padding-top: 26px;
    padding-bottom: 26px;
  }
}
</style>
